// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2fopJ","content":"LayoutSettings_content__2a5k5"};